export default class FeatureController {

  constructor(panel, $state) {
    this.panel = panel;
    this.$state = $state;
    this.urlParams = panel.getUrlParams();
    this.user = this.panel.getUser();

    this.loggedIn = this.panel.isLoggedIn();

    if (this.loggedIn) {
      if (!this.panel.hasCompletedProfile()) {
        history.pushState(null, 'Edit Profile', '/edit/profile');
        return;
      } else if (!this.panel.hasCompletedMatch()) {
        history.pushState(null, 'Edit Match', '/edit/ideal-match');
        return;
      }
    }

    this.panel.checkAuth($state);

    if ($state.data && $state.data.pageTitle) {
      console.log('Feature has data');
      $('title').html($state.data.pageTitle);
    }

    window.scrollTo(0, 0);

    if ($state.current.url === '/inbox/:folder/:person') {
      $('.the-main-menu').hide();
    } else {
      $('.the-main-menu').show();
    }
  }

  scrollLoad(callback) {
    let win = $(window);
    win.scroll(function() {
      if (win.scrollTop() === $(document).height() - win.height()) {
        if (typeof callback === 'function') {
          callback();
        }
      }
    });
  }

  initSearch() {
    this.preferences = {};
    this.matches = [];
    this.age_range = this.panel.range(17, 100);
    this.complete = false;
    this.isInlineSearch = false;

    const self = this;
    this.panel.get('/v1/matches/preferences', (response) => {
      if (self.panel.okay(response)) {
        self.activities = response.activities;
        self.options = response.options;
        self.match_preferences = response.match_preferences;
        self.search_preferences = response.search_preferences;
        self.search();
      }
    });
  }

  setCurrentPage (num) {
    this.current_page = num;
  }

  search () {
    const self = this;
    let page = this.current_page ? this.next_page : 1;
    let search_criteria = '';
    if (page) {
      if (this.search_criteria) {
        search_criteria += '&';
        for (let i in this.search_criteria) {
          search_criteria += (i+'='+this.search_criteria[i]+'&');
        }
      }
      this.panel.get(this.endpoint + '?page=' + page + search_criteria, (response) => {
        self.hasSearched = true;
        if (self.panel.okay(response)) {
          self.setSearchResults(response.data);
          if (!self.scrolling) {
            self.scrolling = true;
            self.scrollLoad(() => {
              self.search();
            })
          }
        }
      });
    }
  }

  setSearchResults (data) {
    this.current_page = data.current_page;
    this.per_page = data.per_page;
    this.total = data.total;
    this.pages = Math.ceil(this.total/this.per_page);
    this.next_page = this.current_page < this.pages ?  parseInt(this.current_page)+1 : false;
    if (!this.next_page) {
      this.complete = true;
    }
    if (this.matches.length === 0 || this.isInlineSearch) {
      this.matches = data.matches;
      this.isInlineSearch = false;
    } else {
      for (let i in data.matches) {
        this.matches.push(data.matches[i]);
      }
    }
  }

  p_feature (id, options, is_array) {

    if(id == null) return 'n/a';

    let items = [];

    if (typeof is_array === 'undefined'){
      items = id.indexOf(',') > -1 ? id.split(',') : [id];
    }
    else {
      items = id;
    }

    let desc = '';

    for (let j in items) {

      for (let i in options) {

        if (parseFloat(options[i]['id']) === parseFloat(items[j])){

          if(!$.isNumeric(options[i]['description'])){

            desc = desc+options[i]['description']+', ';
          }
          else{

            desc = desc+options[i]['description'];
          }
        }
      }
    }

    if (desc.indexOf(',') > -1) return desc.substring(0, desc.length-2);

    return desc;
  }
}



// WEBPACK FOOTER //
// ./src/app/features/FeatureController.js